import PropTypes from 'prop-types';

import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const ReactSelectCodeAPE = ({ placeholder, ...otherProps }) => {
  const { isLoading, data } = useQueryOnce({
    queryKey: ['codeAPE'],
    queryFn: () =>
      axios
        .get(Routes.search_ape_code_path({ format: 'json' }))
        .then(({ data }) => data),
  });

  return (
    <ReactSelectInput
      {...otherProps}
      options={data}
      placeholder={
        placeholder ||
        I18n.t('activerecord.attributes.companies/company.code_naf')
      }
      isLoading={isLoading}
    />
  );
};

ReactSelectCodeAPE.propTypes = {
  placeholder: PropTypes.string,
};

export default ReactSelectCodeAPE;
